import { Typography, Box, useTheme } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface StepProps {
  title: string;
  description: string;
}

export default function TextStep({ title, description }: StepProps) {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor={theme.palette.darkerLightGrey.main}
        borderRadius={2}
        width={48}
        height={48}
        flexShrink={0}>
        <ArrowForwardIcon />
      </Box>
      <Box display="flex" flexDirection="column" justifyContent="center">
        <Typography
          variant="subtitle1"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          }}>
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
